import { render, staticRenderFns } from "./fullImage.vue?vue&type=template&id=1f1cc4f6&scoped=true&"
import script from "./fullImage.vue?vue&type=script&lang=js&"
export * from "./fullImage.vue?vue&type=script&lang=js&"
import style0 from "./fullImage.vue?vue&type=style&index=0&id=1f1cc4f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cc4f6",
  null
  
)

export default component.exports